export const AVATAR_COLOR_COUNT = 4;

/**
 * Assigns each identity a palette slot by the order it first appears, so a
 * family of four gets four distinct colours and everyone keeps the same colour
 * no matter which card list they are rendered in.
 */
export const buildAvatarColorMap = (identities: string[]) => {
  const colorByIdentity = new Map<string, number>();

  identities.forEach((identity) => {
    if (colorByIdentity.has(identity)) {
      return;
    }

    colorByIdentity.set(identity, colorByIdentity.size % AVATAR_COLOR_COUNT);
  });

  return colorByIdentity;
};
